import * as React from 'react';

const iconImageURL = require('../../assets/icons/call.jpg');

export default () => <img src={iconImageURL} />;
